import { render, staticRenderFns } from "./PropsDisplayModal.vue?vue&type=template&id=c03e36fe&scoped=true"
import script from "./PropsDisplayModal.vue?vue&type=script&lang=js"
export * from "./PropsDisplayModal.vue?vue&type=script&lang=js"
import style0 from "./PropsDisplayModal.vue?vue&type=style&index=0&id=c03e36fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03e36fe",
  null
  
)

export default component.exports